import { IisEqual } from '@datachain/ui-sdk/common';
import { AppTagItemEntity } from '@datachain/ui-sdk/components/dc-types';
import { immerable } from 'immer';
import { OrderedSet } from 'immutable';

type SynthesisType = 'Additive' | 'Restrictive';

interface IExpositionEndpointMetadataEntity {
	id: number;
	accessPoint: string;
	title: string;
	details: string;
	keywords: OrderedSet<AppTagItemEntity>;
	synthesisType: SynthesisType;
}

const entityDefaults: IExpositionEndpointMetadataEntity = {
	id: -1,
	accessPoint: '',
	title: '',
	details: '',
	keywords: OrderedSet(),
	synthesisType: 'Restrictive',
};

export class ExpositionEndpointMetadataEntity
	implements
		IExpositionEndpointMetadataEntity,
		IisEqual<ExpositionEndpointMetadataEntity>
{
	private [immerable] = true;
	public id = entityDefaults.id;
	public accessPoint = entityDefaults.accessPoint;
	public title = entityDefaults.title;
	public details = entityDefaults.details;
	public keywords = entityDefaults.keywords;
	public synthesisType = entityDefaults.synthesisType;

	public static build(
		params: Partial<IExpositionEndpointMetadataEntity> = {}
	): ExpositionEndpointMetadataEntity {
		const instance = new ExpositionEndpointMetadataEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.accessPoint = params.accessPoint ?? entityDefaults.accessPoint;
		instance.title = params.title ?? entityDefaults.title;
		instance.details = params.details ?? entityDefaults.details;
		instance.keywords = params.keywords ?? entityDefaults.keywords;
		instance.synthesisType =
			params.synthesisType ?? entityDefaults.synthesisType;
		return instance;
	}
	public isEqualTo(obj: ExpositionEndpointMetadataEntity): boolean {
		if (this.accessPoint !== obj.accessPoint) {
			return false;
		} else if (this.title !== obj.title) {
			return false;
		} else if (this.details !== obj.details) {
			return false;
		} else if (this.keywords.size !== obj.keywords.size) {
			return false;
		} else if (this.synthesisType !== obj.synthesisType) {
			return false;
		}
		return true;
	}
}
